<script>
  import EmptyLegMap from "../components/EmptyLegMap.svelte";

  export let googleMapsReady;
</script>

{#if googleMapsReady}
  <EmptyLegMap />
{/if}
